// extracted by mini-css-extract-plugin
export default {"label":"MarketingCheckbox_label__Uc1b3"};